"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultAssetKey = exports.SearchResultTabKeyEnum = void 0;
var SearchResultTabKeyEnum;
(function (SearchResultTabKeyEnum) {
    SearchResultTabKeyEnum["Pages"] = "pages";
    SearchResultTabKeyEnum["Products"] = "products";
    SearchResultTabKeyEnum["Documents"] = "documents";
    SearchResultTabKeyEnum["Drawings"] = "drawings";
    SearchResultTabKeyEnum["Downloads"] = "downloads";
})(SearchResultTabKeyEnum || (exports.SearchResultTabKeyEnum = SearchResultTabKeyEnum = {}));
var SearchResultAssetKey;
(function (SearchResultAssetKey) {
    SearchResultAssetKey["Documents"] = "documents";
    SearchResultAssetKey["Drawings"] = "drawings";
    SearchResultAssetKey["Softwares"] = "softwares";
})(SearchResultAssetKey || (exports.SearchResultAssetKey = SearchResultAssetKey = {}));
